import React, { useState } from "react";
import { injectIntl } from "react-intl";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ListContainer from "./ListContainer";
import { selectImageId, selectImageStatus } from "redux/image/selectors";
import { deleteAllShape } from "redux/shape/actions";
import { setModalItem } from "redux/canvas/actions";
import { getLabelsOfShapes } from "redux/shape/selector";
import styles from "./style.module.scss";
import { object, string, func, array } from "prop-types";
import { connect, useSelector } from "react-redux";
import { selectCanPermissionEditAndLabelingTab } from "redux/app/selectors";

function ShapeList({
  intl,
  imageId,
  imageStatus,
  deleteAllShape,
  setModalItem,
  shapeLabels,
}) {
  const permissionEdit = useSelector(
    selectCanPermissionEditAndLabelingTab(imageStatus)
  );
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleCollapse = () => {
    setIsCollapsed((prevState) => !prevState);
  };
  const handleDeleteAllLabel = () => {
    setModalItem({
      payload: { imageId },
      fn: deleteAllShape,
      title: intl.formatMessage({ id: "shape-list.delete-all" }),
      content: intl.formatMessage({ id: "shape-list.confirm-delete-all" }),
      id: imageId,
      fnAction: null,
    });
  };

  const hasLabels = shapeLabels && shapeLabels.length > 0;

  return (
    <div className={styles.container} data-tour="box-list">
      <div className={styles.titleWrapper} tabIndex="0">
        <button
          type="button"
          className={styles.collapse}
          onClick={handleCollapse}
        >
          {isCollapsed ? <ChevronRight /> : <ExpandMore />}
        </button>
        <div className={styles.box}>
          <span>{intl.formatMessage({ id: "shape-list.item-list" })}</span>
          {hasLabels && (
            <button
              className={
                !permissionEdit
                  ? styles.deleteAllLabelViewer
                  : styles.deleteAllLabel
              }
              type="button"
              disabled={!permissionEdit}
              onClick={handleDeleteAllLabel}
            >
              <span>
                {intl.formatMessage({ id: "shape-list.delete-all-labels" })}
              </span>
            </button>
          )}
        </div>
      </div>
      {isCollapsed ? null : <ListContainer shapeLabels={shapeLabels} />}
    </div>
  );
}

ShapeList.propTypes = {
  intl: object,
  imageId: string,
  imageStatus: string,
  deleteAllShape: func,
  setModalItem: func,
  shapeLabels: array,
};

function mapState(state) {
  return {
    imageId: selectImageId(state),
    imageStatus: selectImageStatus(state),
    shapeLabels: getLabelsOfShapes()(state),
  };
}

export default connect(mapState, { deleteAllShape, setModalItem })(
  injectIntl(ShapeList)
);
